<section>
  <app-dashboard-filter
    class="justify-content-center"
    (filterEmmiter)="setFilter($event)"
  ></app-dashboard-filter>

  <div class="big-numbers-container">
    <div class="big-numbers">
      <app-dashboard-big-number
        [title]="'Ligações Analisadas'"
        [content]="totalTranscriptionsByPeriod"
        [loading]="loadingTranscriptionsByPeriod"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Ligações < 500 seg'"
        [content]="tmaLowerThen500s"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Short Call'"
        [content]="shortCalls"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Categorias Mencionadas'"
        [content]="totalMentionedCategories"
        [loading]="loadingMentionedCategories"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Palavras Mencionadas'"
        [content]="totalMentionedKeywords"
        [loading]="loadingMentionedKeywords"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'% Non Talk'"
        [content]="
          averageNonTalkPercentage !== undefined &&
          !isNaN(averageNonTalkPercentage)
            ? averageNonTalkPercentage + '%'
            : undefined
        "
        [loading]="loadingDailyNonTalk"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Solicitou um Momento'"
        [content]="aMomentTimeRequested"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'ID Positiva'"
        [content]="positiveIdTime"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Média TMA'"
        [content]="averageTma"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Prontidão Excedido'"
        [content]="readinessTimeExceeded"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Retorno Excedido'"
        [content]="returnTimeExceeded"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Solicitação do Cliente'"
        [content]="clientRequestTime"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Segurando Linha'"
        [content]="holdingLineTime"
        [loading]="loadingBigNumbers"
      ></app-dashboard-big-number>

      <app-dashboard-big-number
        [title]="'Média TMA em seg'"
        [content]="parseFloat(tmaInSeconds.toFixed(2))"
        [loading]="loadingTmaXNonTalkBySegment"
      ></app-dashboard-big-number>
    </div>
  </div>

  <div class="insights-container">
    <app-dashboard-resolution-insights
      class="justify-content-center resolution-item"
      [filter]="filter"
    ></app-dashboard-resolution-insights>
  </div>

  <div class="resolution">
    <app-dashboard-shortcalls-total
      class="resolution-item"
      [shortCalls]="shortCalls"
      [otherTranscriptions]="totalTranscriptionsByPeriod - shortCalls"
      [loading]="loadingTranscriptionsByPeriod || loadingBigNumbers"
    ></app-dashboard-shortcalls-total>

    <app-dashboard-first-call-resolution
      [filter]="filter"
      class="resolution-item"
    ></app-dashboard-first-call-resolution>

    <app-dashboard-resolution-chart
      [filter]="filter"
      class="resolution-item"
    ></app-dashboard-resolution-chart>
  </div>

  <app-dashboard-tabs (emmiter)="selectTab($event)">
    <app-dashboard-tab-item [title]="'1'" #tab1.1>
      <app-dashboard-transcriptions-client
        #chart1.1
        class="justify-content-center"
        [filter]="filter"
        (totalTranscriptions)="setTotalTranscriptionsByPeriod($event)"
        (isLoadingEmmiter)="setLoadingTranscriptionsByPeriod($event)"
      ></app-dashboard-transcriptions-client>
    </app-dashboard-tab-item>

    <app-dashboard-tab-item [title]="'2'" #tab1.2>
      <app-dashboard-mentioned-categories-ranking
        #chart1.2
        class="justify-content-center"
        [filter]="filter"
        (totalMentions)="setTotalMentionedCategories($event)"
        (isLoadingEmmiter)="setLoadingMentionedCategories($event)"
      ></app-dashboard-mentioned-categories-ranking>
    </app-dashboard-tab-item>

    <app-dashboard-tab-item [title]="'3'" #tab1.3 class="tabs-item">
      <app-dashboard-mentioned-keywords-ranking
        #chart1.3
        class="justify-content-center"
        [filter]="filter"
        (totalMentions)="setTotalMentionedKeywords($event)"
        (isLoadingEmmiter)="setLoadingMentionedKeywords($event)"
      ></app-dashboard-mentioned-keywords-ranking>
    </app-dashboard-tab-item>
  </app-dashboard-tabs>

  <app-dashboard-tabs (emmiter)="selectTab($event)" [tabText]="true">
    <app-dashboard-tab-item [title]="'Macro'" #tab4.1>
      <app-dashboard-mentioned-macro-contact-reasons-ranking
        #chart4.1
        class="justify-content-center"
        [filter]="filter"
        (isLoadingEmmiter)="setLoadingTranscriptionsByPeriod($event)"
      ></app-dashboard-mentioned-macro-contact-reasons-ranking>
    </app-dashboard-tab-item>

    <app-dashboard-tab-item [title]="'Micro'" #tab4.2>
      <app-dashboard-mentioned-micro-contact-reasons-ranking
        #chart4.2
        class="justify-content-center"
        [filter]="filter"
        (isLoadingEmmiter)="setLoadingTranscriptionsByPeriod($event)"
      ></app-dashboard-mentioned-micro-contact-reasons-ranking>
    </app-dashboard-tab-item>
  </app-dashboard-tabs>

  <div class="tabs-container">
    <app-dashboard-tabs (emmiter)="selectTab($event)">
      <app-dashboard-tab-item [title]="'1'" #tab2.1>
        <app-dashboard-tma-x-non-talk-by-segment
          #chart2.1
          class="justify-content-center"
          [filter]="filter"
          (tmaInSeconds)="setTMAInSeconds($event)"
          (isLoadingEmmiter)="setLoadingTmaXNonTalkBySegment($event)"
        ></app-dashboard-tma-x-non-talk-by-segment>
      </app-dashboard-tab-item>

      <app-dashboard-tab-item [title]="'2'" #tab2.2>
        <app-dashboard-daily-tma
          #chart2.2
          class="justify-content-center"
          [filter]="filter"
          (isLoadingEmmiter)="setLoadingDailyTMA($event)"
        >
        </app-dashboard-daily-tma>
      </app-dashboard-tab-item>

      <app-dashboard-tab-item [title]="'3'" #tab2.3>
        <app-dashboard-daily-non-talk
          #chart2.3
          class="justify-content-center"
          [filter]="filter"
          (averageNonTalkPercentage)="setAverageNonTalkPercentage($event)"
          (isLoadingEmmiter)="setLoadingDailyNonTalk($event)"
        >
        </app-dashboard-daily-non-talk>
      </app-dashboard-tab-item>
    </app-dashboard-tabs>

    <app-dashboard-tabs (emmiter)="selectTab($event)" class="tabs-item">
      <app-dashboard-tab-item [title]="'1'" #tab1.1>
        <app-dashboard-top5-metrics
          #chart1.1
          class="justify-content-center tabs-item"
          [filter]="filter"
          type="unresolved-reasons"
        ></app-dashboard-top5-metrics>
      </app-dashboard-tab-item>

      <app-dashboard-tab-item [title]="'2'" #tab1.2>
        <app-dashboard-top5-metrics
          #chart1.2
          class="justify-content-center tabs-item"
          [filter]="filter"
          type="resolutive-reasons"
        ></app-dashboard-top5-metrics>
      </app-dashboard-tab-item>

      <app-dashboard-tab-item [title]="'3'" #tab1.3 class="tabs-item">
        <app-dashboard-top5-metrics
          #chart1.3
          class="justify-content-center"
          [filter]="filter"
          type="worst-attendants"
        ></app-dashboard-top5-metrics>
      </app-dashboard-tab-item>

      <app-dashboard-tab-item [title]="'4'" #tab1.3 class="tabs-item">
        <app-dashboard-top5-metrics
          #chart1.4
          class="justify-content-center"
          [filter]="filter"
          type="best-attendants"
        ></app-dashboard-top5-metrics>
      </app-dashboard-tab-item>
    </app-dashboard-tabs>
  </div>

  <app-dashboard-tabs (emmiter)="selectTab($event)">
    <app-dashboard-tab-item [title]="'1'" #tab3.1>
      <app-dashboard-shifts
        #chart3.1
        class="justify-content-center"
        [filter]="filter"
        (isLoadingEmmiter)="setLoadingShifts($event)"
      ></app-dashboard-shifts>
    </app-dashboard-tab-item>
  </app-dashboard-tabs>
</section>
